const LOG_PREFIX = `@wix/design-system: [WARNING] `;
let deprecationTestkitLog = () => {};

deprecationTestkitLog = msg => console.warn(`${LOG_PREFIX}${msg}`);

export default deprecationTestkitLog;
